import { render, staticRenderFns } from "./StudyRecordLog.vue?vue&type=template&id=2fbd1478&scoped=true&"
import script from "./StudyRecordLog.vue?vue&type=script&lang=js&"
export * from "./StudyRecordLog.vue?vue&type=script&lang=js&"
import style0 from "./StudyRecordLog.vue?vue&type=style&index=0&id=2fbd1478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd1478",
  null
  
)

export default component.exports